export const STORYBOOK_TITLES = {
  components: (path: string) => 'components/'.concat(path),
  hooks: (path: string) => 'hooks/'.concat(path),
  packages: (path: string) => 'packages/'.concat(path),
  utils: (path: string) => 'utils/'.concat(path),
  styles: (path: string) => 'styles/'.concat(path),
};
